/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getLensPrescriptions } from 'app/entities/lens-prescription/lens-prescription.reducer';
import { getEntities as getEyes } from 'app/entities/eye/eye.reducer';
import { VisionProductType } from 'app/shared/model/enumerations/vision-product-type.model';
import { EyeSide } from 'app/shared/model/enumerations/eye-side.model';
import { PrismVisualBase } from 'app/shared/model/enumerations/prism-visual-base.model';
import { EyeReadingType } from 'app/shared/model/enumerations/eye-reading-type.model';
import { createEntity, getEntity, reset, updateEntity } from './lens-specification.reducer';

export const LensSpecificationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const lensPrescriptions = useAppSelector(state => state.lensPrescription.entities);
  const eyes = useAppSelector(state => state.eye.entities);
  const lensSpecificationEntity = useAppSelector(state => state.lensSpecification.entity);
  const loading = useAppSelector(state => state.lensSpecification.loading);
  const updating = useAppSelector(state => state.lensSpecification.updating);
  const updateSuccess = useAppSelector(state => state.lensSpecification.updateSuccess);
  const visionProductTypeValues = Object.keys(VisionProductType);
  const eyeSideValues = Object.keys(EyeSide);
  const prismVisualBaseValues = Object.keys(PrismVisualBase);
  const eyeReadingTypeValues = Object.keys(EyeReadingType);

  const handleClose = () => {
    navigate(`/lens-specification${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLensPrescriptions({}));
    dispatch(getEyes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.issuedDate !== undefined && typeof values.issuedDate !== 'number') {
      values.issuedDate = Number(values.issuedDate);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.sphere !== undefined && typeof values.sphere !== 'number') {
      values.sphere = Number(values.sphere);
    }
    if (values.cylinder !== undefined && typeof values.cylinder !== 'number') {
      values.cylinder = Number(values.cylinder);
    }
    if (values.axis !== undefined && typeof values.axis !== 'number') {
      values.axis = Number(values.axis);
    }
    if (values.prismAmount !== undefined && typeof values.prismAmount !== 'number') {
      values.prismAmount = Number(values.prismAmount);
    }
    if (values.mlPower !== undefined && typeof values.mlPower !== 'number') {
      values.mlPower = Number(values.mlPower);
    }
    if (values.clPower !== undefined && typeof values.clPower !== 'number') {
      values.clPower = Number(values.clPower);
    }
    if (values.clBackCurve !== undefined && typeof values.clBackCurve !== 'number') {
      values.clBackCurve = Number(values.clBackCurve);
    }
    if (values.clDiameter !== undefined && typeof values.clDiameter !== 'number') {
      values.clDiameter = Number(values.clDiameter);
    }
    if (values.wearingDuration !== undefined && typeof values.wearingDuration !== 'number') {
      values.wearingDuration = Number(values.wearingDuration);
    }

    const entity = {
      ...lensSpecificationEntity,
      ...values,
      prescription: lensPrescriptions.find(it => it.id.toString() === values.prescription?.toString()),
      eye: eyes.find(it => it.id.toString() === values.eye?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          visionProductType: 'LENS',
          eyeSide: 'LEFT',
          prismBase: 'UP',
          eyeReadingType: 'OLD',
          ...lensSpecificationEntity,
          prescription: lensSpecificationEntity?.prescription?.id,
          eye: lensSpecificationEntity?.eye?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.lensSpecification.home.createOrEditLabel" data-cy="LensSpecificationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.lensSpecification.home.createOrEditLabel">Create or edit a LensSpecification</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lens-specification-id"
                  label={translate('tinyMedicRestApp.lensSpecification.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.issuedDate')}
                id="lens-specification-issuedDate"
                name="issuedDate"
                data-cy="issuedDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.active')}
                id="lens-specification-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.timestampEntry')}
                id="lens-specification-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.microSec')}
                id="lens-specification-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.lastUpdated')}
                id="lens-specification-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.cursor')}
                id="lens-specification-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.visionProductType')}
                id="lens-specification-visionProductType"
                name="visionProductType"
                data-cy="visionProductType"
                type="select"
              >
                {visionProductTypeValues.map(visionProductType => (
                  <option value={visionProductType} key={visionProductType}>
                    {translate(`tinyMedicRestApp.VisionProductType.${visionProductType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.eyeSide')}
                id="lens-specification-eyeSide"
                name="eyeSide"
                data-cy="eyeSide"
                type="select"
              >
                {eyeSideValues.map(eyeSide => (
                  <option value={eyeSide} key={eyeSide}>
                    {translate(`tinyMedicRestApp.EyeSide.${eyeSide}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.sphere')}
                id="lens-specification-sphere"
                name="sphere"
                data-cy="sphere"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.cylinder')}
                id="lens-specification-cylinder"
                name="cylinder"
                data-cy="cylinder"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.axis')}
                id="lens-specification-axis"
                name="axis"
                data-cy="axis"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.prismAmount')}
                id="lens-specification-prismAmount"
                name="prismAmount"
                data-cy="prismAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.prismBase')}
                id="lens-specification-prismBase"
                name="prismBase"
                data-cy="prismBase"
                type="select"
              >
                {prismVisualBaseValues.map(prismVisualBase => (
                  <option value={prismVisualBase} key={prismVisualBase}>
                    {translate(`tinyMedicRestApp.PrismVisualBase.${prismVisualBase}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.mlPower')}
                id="lens-specification-mlPower"
                name="mlPower"
                data-cy="mlPower"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.clPower')}
                id="lens-specification-clPower"
                name="clPower"
                data-cy="clPower"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.clBackCurve')}
                id="lens-specification-clBackCurve"
                name="clBackCurve"
                data-cy="clBackCurve"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.clDiameter')}
                id="lens-specification-clDiameter"
                name="clDiameter"
                data-cy="clDiameter"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.wearingDuration')}
                id="lens-specification-wearingDuration"
                name="wearingDuration"
                data-cy="wearingDuration"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.color')}
                id="lens-specification-color"
                name="color"
                data-cy="color"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.brand')}
                id="lens-specification-brand"
                name="brand"
                data-cy="brand"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.notes')}
                id="lens-specification-notes"
                name="notes"
                data-cy="notes"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.lensSpecification.eyeReadingType')}
                id="lens-specification-eyeReadingType"
                name="eyeReadingType"
                data-cy="eyeReadingType"
                type="select"
              >
                {eyeReadingTypeValues.map(eyeReadingType => (
                  <option value={eyeReadingType} key={eyeReadingType}>
                    {translate(`tinyMedicRestApp.EyeReadingType.${eyeReadingType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="lens-specification-prescription"
                name="prescription"
                data-cy="prescription"
                label={translate('tinyMedicRestApp.lensSpecification.prescription')}
                type="select"
              >
                <option value="" key="0" />
                {lensPrescriptions
                  ? lensPrescriptions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lens-specification-eye"
                name="eye"
                data-cy="eye"
                label={translate('tinyMedicRestApp.lensSpecification.eye')}
                type="select"
              >
                <option value="" key="0" />
                {eyes
                  ? eyes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lens-specification" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LensSpecificationUpdate;
